module.exports = __webpack_public_path__ + "static/media/nd.85a603b2.png";